import react from "react";
import image1 from "../images/mobile.webp";
import image2 from "../images/laptop.jpg";
import image3 from "../images/headphone.webp";
import image4 from "../images/camera.png";
import image5 from "../images/smartwatch.jpeg";
import image6 from "../images/tablet.jpeg";
import image7 from "../images/Keyboard.jpeg";
import image8 from "../images/Mouse.jpeg";
import image9 from "../images/camera.png";
import image10 from "../images/bluetoothSpeaker.jpeg";

export const productsList = [
  { id: 1, img: image1, name: "Mobile", price: 15000, quantity: 1 },
  { id: 2, img: image2, name: "Laptop", price: 45000, quantity: 1 },
  { id: 3, img: image3, name: "Headphones", price: 2000, quantity: 1 },
  { id: 4, img: image4, name: "Camera", price: 32000, quantity: 1 },
  { id: 5, img: image5, name: "Smart Watch", price: 5000, quantity: 1 },
  { id: 6, img: image6, name: "Tablet", price: 22000, quantity: 1 },
  { id: 7, img: image7, name: "Keyboard", price: 1200, quantity: 1 },
  { id: 8, img: image8, name: "Mouse", price: 800, quantity: 1 },
  { id: 9, img: image9, name: "Charger", price: 600, quantity: 1 },
  { id: 10, img: image10, name: "Speaker", price: 3500, quantity: 1 },
];

export default productsList;
